export class AcademicHistorySummary {
    Id: number;
    WeightedGPA: number;
    UnWeightedGPA: number;
    ClassRankIn: number;
    ClassRankOut: number;
    V9Flag: boolean;
    CalculatedOn: Date;
    CalculatedBy: string;
    RankCalculatedOn: Date;
    RankCalculatedBy: string;
    RankOutdated: boolean;
    S360ClassRank: boolean;
}